import { cn } from "./cn";

/**
 * A compact two or three way switch.
 *
 * For a choice small enough that hiding the options behind a select would cost
 * more than showing them: the comparison basis on the sales analysis, the kind
 * of invoice on the manual invoices page. Anything longer wants a Select.
 */
export function Segmented<T extends string>({
  value,
  onChange,
  options,
}: {
  value: T;
  onChange: (next: T) => void;
  options: Array<{ value: T; label: string }>;
}) {
  return (
    <div className="inline-flex rounded-md border border-line bg-surface-sunk p-0.5">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          aria-pressed={value === option.value}
          className={cn(
            "rounded px-2.5 py-1 text-[12px] font-medium transition",
            value === option.value
              ? "bg-accent-soft text-accent-strong shadow-sm"
              : "text-ink-muted hover:text-ink",
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
